import type { GuideAction } from "../api/guide";
import { storage } from "./storage";

export type StoredGuideMessage = {
  id: string;
  role: "user" | "assistant";
  content: string;
  actions?: GuideAction[];
  source?: "llm" | "fallback" | "kb";
};

const MAX_MESSAGES = 80;

function storageKey(userId: string, eventId: string, lang: string): string {
  return `guideChat_${userId}_${eventId}_${lang}`;
}

function sanitize(messages: StoredGuideMessage[]): StoredGuideMessage[] {
  return messages
    .filter(
      (m) =>
        (m.role === "user" || m.role === "assistant") &&
        typeof m.content === "string" &&
        m.content.trim().length > 0,
    )
    .slice(-MAX_MESSAGES)
    .map((m) => ({
      id: m.id || `${Date.now()}`,
      role: m.role,
      content: m.content.trim(),
      ...(m.actions?.length ? { actions: m.actions } : {}),
      ...(m.source ? { source: m.source } : {}),
    }));
}

export function loadGuideHistory(
  userId: string,
  eventId: string,
  lang: string,
): StoredGuideMessage[] {
  if (!userId || !eventId) return [];
  return sanitize(storage.get<StoredGuideMessage[]>(storageKey(userId, eventId, lang), []));
}

export function saveGuideHistory(
  userId: string,
  eventId: string,
  lang: string,
  messages: StoredGuideMessage[],
): void {
  if (!userId || !eventId) return;
  storage.set(storageKey(userId, eventId, lang), sanitize(messages));
}

export function clearGuideHistory(userId: string, eventId: string, lang: string): void {
  if (!userId || !eventId) return;
  storage.remove(storageKey(userId, eventId, lang));
}
